import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appMin]',
  providers: [{provide: NG_VALIDATORS, useExisting: MinValidatorDirective, multi: true}]
})
export class MinValidatorDirective implements Validator {

  @Input('appMin') minValue:number;
  constructor() { 
  }
  validate(control: AbstractControl): ValidationErrors | null {
    return control.value >= this.minValue ? null : {min: false} 
  }
}
